import { useCallback, useEffect, useState } from 'react'

import { showLoading } from 'services/util'

import { handleEscapeKey } from 'sites/auctions/components/utils'
import NumberRow from './NumberRow'
import css from '../../components/sass/confirmmodal.module.scss'
import themeCss from '../../components/sass/theme.module.scss'

export default function ConfirmMarkAsPaid({setShowConfirmModal, updateItem, data}) {

  const [itemTitle, setItemTitle] = useState()

  const loggedInUser = data.loggedInUser

  const toggleModal = useCallback(() => {
      setShowConfirmModal(false)
    }, [setShowConfirmModal])
  
  useEffect(() => {
    const onKeyDown = (event) => handleEscapeKey(event, toggleModal)
    //add event listener for when modal is mounted
    document.addEventListener('keydown', onKeyDown)
    //clean up when modal is unmounted
    return () => document.removeEventListener('keydown', onKeyDown)

  }, [toggleModal])

  //use effect to set the title for the mark as paid window
  useEffect(() => {

    if (data?.auctionDetail) {
      const matchingItem = data.auctionDetail.Items.find(ele => ele.ItemId === data.itemsMarkedPaid[0])
      setItemTitle(matchingItem.Title)
    }

  }, [data] )

  const performConfirm = (test) => {
    const input = {
      ItemId: data.itemsMarkedPaid[0],
    }

    if (test) {
      input['Paid'] = null
      input['PaymentDetails'] = null
    } else {
      input['Paid'] = true
      input['PaymentDetails'] = JSON.stringify({ message: "Marked as paid by admin: " + loggedInUser.cognitoUser.username })
    }

    showLoading(true)
    updateItem(input)
  }

  return (
    <div className={css['modal-container']}>
      <div className={themeCss['modal-background']} onClick={()=>toggleModal()}> </div>
      <div className={`${css['modal-content']} }`}>

        <div>
          <div className={css['withdata-text']}>
            <h3>CONFIRM MARKING ITEMS AS PAID</h3>

            {data.itemsMarkedPaid && <>
              <div className={css['number-row']}><h4>{itemTitle?.toUpperCase()}</h4><p>BEING MARKED AS PAID FOR {data?.attendeeName?.toUpperCase()}</p></div>
              <NumberRow number={data.totalMarkedPaid} dollar={true} text={'TOTAL BEING MARKED AS PAID'} />
            </>}
            
          </div> 
        </div>

        {/* {data.errorMessage && <p>Error</p>} */}

        <div className={css['button-options']}>
          <button className={`${themeCss['button']} ${themeCss['FilledWhite']} ${themeCss['centered-button']}`}
            onClick={()=>toggleModal()}>Cancel</button>          
          <button className={`${themeCss['FilledBlue']} ${themeCss['button']} ${themeCss['centered-button']} ${css['modal-buttontext-fixing']}`} 
            onClick={()=> performConfirm()}>Confirm Mark As Paid</button>
          
          {/* 
          //leave in for testing purposes
          <button 
            className={`${themeCss['FilledYellow']} ${themeCss['button']} ${themeCss['centered-button']} ${css['modal-buttontext-fixing']}`} 
            onClick={()=> performConfirm(true)}>Test-Unpaid</button> */}

        </div>
      </div>    
    </div>
  )
}